import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {applicantGetRecord, applicantValidateOTP} from '../../../auth/core/_requests'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useAuth} from '../../../auth/core/Auth'
import { StatusErrorMessage } from '../../../../components/widgets'
import { getErrorMessage } from '../../../../components/helpers'

const loginOTPSchema = Yup.object().shape({
  otp: Yup.string().trim()
    .min(2, 'Minimum 2 symbols')
    .max(16, 'Maximum 50 symbols')
    .required('OTP is required'),
})

const initialValues = {
  otp: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function CompanyLoginOTP() {
  
  const {auth, saveAuth, setCurrentUser} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginOTPSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      
      const params = {
        email :auth ? auth.email : '',
        password : auth ? auth.password : '',
        otp: values.otp
      }

      async function validateOTP(data: any) {
        await applicantValidateOTP(data.email, data.password, data.otp)
        .then((res) => {
          if (! (res && res.loggedIn)) {
            setStatus((res?.message) ? res.message : 'Something happened');
            return;                        
          }

          const new_auth = {
            id: res.id, 
            email: res.email, 
            name: res.name,
            role: res.role,
            password: '',
            loggedIn: res.loggedIn,                        
            isSetsco: false
          }
                              
          saveAuth(new_auth);
          setCurrentUser({
            id : new_auth.id,
            email : new_auth.email,
            name : new_auth.name ? new_auth.name : '',
            role : new_auth.role ? new_auth.role : '',
            designation: '',
            isSetsco: false,
          });

          // get latest record
          applicantGetRecord()
          .then( ({data: record}) => {
            if (record) {
              Object.assign( record, { isSetsco: false});
              setCurrentUser(record)
            }
          })
          .catch((err) => {
            console.error(err);
          });
       })
      .catch((err) => {
        const msg = getErrorMessage(err);
        if (msg.match(/401/)) {
          setStatus('OTP is incorrect.');
        } else {
          setStatus(msg);
        }
      })
      .finally( ()=> {
        setSubmitting(false)          
      })
    }

    await validateOTP(params);

    },
  })

  return (
  <>
  <div>
    <div className="p-6 text-center" style={{marginTop: '-60px'}}>
      <img src={toAbsoluteUrl('/media/brand/Setsco_BrandSig_2D_white.png')} className="h-80px" alt='setsco' />
    </div>
    <form
      className="form w-100 w-lg-400px bg-white rounded-4 overflow-hidden"
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className="bg-primary fs-6 text-white p-6 text-center">
        CERTIFICATION APPLICATION & MANAGEMENT SYSTEM
      </div>
      <div className="p-10 d-flex flex-column gap-4 mb-4">

        <div className="text-center text-primary fw-bold fs-1">
          OTP Verification
        </div>
        <div className="text-center text-primary fs-5">
          Please check your email for OTP.
        </div>
        <div className='fv-row'>
          <input
            placeholder='Enter OTP'
            {...formik.getFieldProps('otp')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.otp && formik.errors.otp},
              {'is-valid': formik.touched.otp && !formik.errors.otp,}
            )}
            type='input'
            name='otp'
            autoComplete='off'
          />
          {formik.touched.otp && formik.errors.otp && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.otp}</span>
            </div>
          </div>
          )}
        </div>

        <StatusErrorMessage status={formik.status} />

        <div className="d-flex flex-stack flex-wrap gap-3 justify-content-start align-items-center mt-6">
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary px-10'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {(!formik.isSubmitting) && <span className='indicator-label'>Login</span>}
            {formik.isSubmitting && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
            )}
          </button>
          <Link to='/auth/login' className="link-primary">
            Back to Login
          </Link>
          <div />
        </div>
      </div>
    </form>
  </div>
  </>
  )
}
